<template>
  <div class=" block">
    <div id="content-listing">
      <transition-group name="lista" tag="div" class="columns is-multiline">
        <div v-for="(article, index) in items" :key="`article-${article.location_id}-${index}`"
          :style="{ transitionDelay: article.delay * 200 + 'ms' }" class="column is-12-mobile is-6-tablet"
          :class="columns">
          <article v-if="isLoading" class="second-card is-shadowless p-0 has-text-transparent skeleton__wrapper"
            :style="{ 'pointerEvents': 'none' }">
            <div class="second-card-image">
              <figure class="image"><span class="skeleton__item__alt"
                  :style="{ width: '100%', height: '100%', display: 'block' }"></span></figure>
            </div>
            <div class="second-card-content px-0 pb-0">
              <div class="content">
                <div class="second-card-title has-text-dark">
                  <h3 :style="{ fontSize: '23px', fontWeight: '500' }"><span class="skeleton__item__alt">Lorem ipsum dolor
                      sit
                      amet consectetur</span></h3>
                </div>
                <div class="meta" :style="{ marginBottom: '10px' }"> <span :style="{ fontSize: '15px' }"
                    class="skeleton__item__alt">Lorem ipsum dolor</span></div>
                <div class="line-clamp-3 htmlContent mb-3 has-link-pink" style="hyphens: none;">
                  <span class="skeleton__item__alt">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus sit odit, possimus libero
                    dignissimos sunt laudantium omnis animi doloremque nobis vero totam ab velit? Explicabo veritatis
                    officiis possimus corrupti animi.
                  </span>
                </div>
                <p></p>
                <div class="tags">
                  <span class="skeleton__item__alt">Lorem</span>
                  <span class="skeleton__item__alt" :style="{ marginLeft: '13px' }">Lorem</span>
                </div>
                <span class="link link-more has-link-pink"><span class="skeleton__item__alt">Lorem ipsum</span></span>
              </div>
            </div>
          </article>
          <article v-else class="second-card is-shadowless p-0">
            <div class="second-card-image">
              <figure class="image"><img loading="lazy" :src="article.image" :alt="article.title"></figure>
            </div>
            <div class="second-card-content px-0 pb-0">
              <div class="content">
                <div class="second-card-title has-text-dark">
                  <h3 :style="{ fontSize: '23px', fontWeight: '500' }"><a v-html="article.title"
                      :target="article.external_link ? '_blank' : '_self'" :href="article.url"></a></h3>
                </div>
                <div class="meta" :style="{ marginBottom: '10px' }"> <time
                    :style="{ fontSize: '15px', color: '#757575', fontWeight: '400' }"
                    :datetime="article.publish_date.ymd" class="date">{{ article.publish_date.mdy }}</time></div>
                <div v-if="article.description" v-html="article.description"
                  class="htmlContent mb-3 has-link-pink" style="hyphens: none;">
                </div>
                <p></p>
                <div class="tags" v-if="article.tags.length">
                  <a v-for="tag in article.tags" :style="{ fontSize: '10px' }" :href="tag.url"
                    class="tag button is-primary is-outlined is-uppercase">{{ tag.name }}</a>
                </div>
                <a :target="article.external_link ? '_blank' : '_self'" :href="article.url"
                  class="link link-more has-link-pink" :class="{ 'link-external': article.external_link }"><span
                    class="has-link-pink">Learn more</span></a>
              </div>
            </div>
          </article>

        </div>
      </transition-group>
      <div v-if="searchInfo.pagination.has_next" class="columns">
        <div class="column is-12 has-text-centered">
          <button class="load-more-link " @click="handleScroll">
            <span class="hidden-text">{{ isLoadingNewPage ? 'Loading...' : 'Load More' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SitePageResults",
  props: {
    cols: {
      type: Number,
      default: 3
    }
  },
  computed: {
    ...mapGetters({
      searchInfo: "getSearchInfo",
      isLoading: "getLoadingState",
      isLoadingNewPage: "getLoadingNewPageState",
      selectedArticle: "getSelectedArticle",
    }),
    items() {
      return this.searchInfo.data.length ? this.searchInfo.data : Array.from({ length: 3 }, (_, i) => ({ location_id: i }))
    },
    columns() {
      switch (this.cols) {
        case 2:
          return 'is-6-desktop'
        case 4:
          return 'is-3-desktop'
        default:
          return 'is-4-desktop'
      }
    }
  },
  methods: {
    getWidthContainer() {
      const appWidth = document.getElementById('app');
      return appWidth.offsetWidth;
    },
    loadArticle(e, article) {
      e.preventDefault();

      this.$store.dispatch("assignSelectedArticle", article);
      this.$store.dispatch("fetchArticleContent", article.location_id);

      if (this.getWidthContainer() < 768) {
        document.getElementById('news-article').scrollIntoView({
          behavior: 'smooth'
        });
      }
    },
    handleScroll: function () {
      this.$store.dispatch('fetchNewPageSearch', this.searchInfo.pagination.next_page);
    }
  }
};
</script>
<style>
.lista-enter-active {
  transition: all 0.4s ease;
}

/* leave-active sin transition = desaparecen instantáneo */
.lista-leave-active {
  transition: none !important;
}

.lista-enter {
  opacity: 0;
  transform: translateY(40px);
}
</style>